import { Fragment } from "react"

import routes, { subjectTypeToSection } from "web/routes/constants"
import { isNonEmptyArray } from "web/services/helpers"
import { Icon } from "web/components"
import { AssetIcon, CompanyIcon, DealIcon, PortfolioIcon } from "web/icons"
import { UserIcon } from "@heroicons/react/20/solid"

const ICON_FOR_TYPE = {
  Asset: AssetIcon,
  Deal: DealIcon,
  Portfolio: PortfolioIcon,
  Company: CompanyIcon,
  Contact: UserIcon,
}

function Match({ field_label, match_value }) {
  const valueList = Array.isArray(match_value) ? match_value : [match_value]

  const valueLabel =
    valueList.length > 5 ? `${valueList.length} items` : valueList.join(", ")

  return (
    <div>
      <span>{field_label}:&nbsp;</span>
      <span>
        <em>{valueLabel}</em>
      </span>
    </div>
  )
}

export default function Result({ result, onResultSelected }) {
  const matchSummary = result.match_details.map((md) => <Match {...md} />)

  const hasMatchSummary = isNonEmptyArray(result.match_details)
  const numberOfMatches = hasMatchSummary && matchSummary.length

  const route = routes.tlo(
    subjectTypeToSection(result.subject_type),
    "all",
    null,
    result.subject_id
  )

  const IconComponent = ICON_FOR_TYPE[result.subject_type]

  function handleResultSelected() {
    window.Turbo.visit(route)
    onResultSelected()
  }

  return (
    <li
      onClick={handleResultSelected}
      className="hover:cursor-pointer hover:bg-primary-10"
    >
      <div className="flex items-center px-4 py-4 sm:px-6">
        <div className="flex min-w-0 flex-1 items-center">
          <div className="flex-shrink-0">
            <IconComponent className="m-auto h-6 w-6 fill-current text-neutral-6" />
          </div>
          <div className="min-w-0 flex-1 px-4">
            <div className="truncate text-sm font-medium text-primary-4">
              <span>{result.name}</span>
              {result.tag && (
                <span className="ml-2 inline-flex items-center rounded-full bg-neutral-10 px-2 py-0.5 text-xs font-medium text-primary-4">
                  {result.tag}
                </span>
              )}
            </div>
            <div className="mt-2 flex items-center gap-x-1.5 text-xs text-neutral-2">
              <div className="flex truncate">
                {matchSummary.map((match, index) => {
                  const hasMoreMatches = numberOfMatches > index + 1

                  return (
                    <Fragment key={index}>
                      {match}
                      {hasMoreMatches && <span>&nbsp;&#8226;&nbsp;</span>}
                    </Fragment>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
        <div className="text-neutral-6">
          <Icon name="chevron-right" />
        </div>
      </div>
    </li>
  )
}
